import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTheme } from 'emotion-theming';
import LandingPageThemes from '../../styling/themes/LandingPageThemes';
import * as buttons from './Buttons';
import withTrackingPropsProvider from '../../hocs/withTrackingPropsProvider';
import HandOffLink from '../../utils/urls/HandOffLink';

/**
 * Button
 * @description
 * This component is a wrapper around our styled buttons that will automatically
 * determine the html element, button type, and component type to use.
 *
 * Button Types:
 *   Current button types include: DefaultButton, OutlineButton, TrackedLink
 *   See src/buttons
 * Component Types:
 *  Component types are determined by whether or not the application has passed in a
 *  component to use (ie a Link with tracking built into from PBR) or if it has an href.
 *  This component will change what it renders based on this hierarchy, rendering either a HandOffLink or button
 * @property {Any} children - Children to render in button tag, usually text or text and svg
 * @property {string} className
 * @property {string} color - Color of button
 * @property {string} href - The optional href for the button.
 * @property {string} identifier - Identifier used by HandOffLink for tracking
 * @property {function} onClick - onClick handler for button
 * @property {string} type - Type of the button: (Default, Outline, Tracked)
 */

export class Button extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    href: PropTypes.string,
    identifier: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(Object.keys(buttons)), // should this be named style?
  };

  static defaultProps = {
    type: 'DefaultButton',
    theme: LandingPageThemes.default,
  };

  componentType() {
    const { href } = this.props;
    if (href) {
      return HandOffLink;
    } else {
      return 'button';
    }
  }

  render() {
    const {
      type,
      theme: { Button },
    } = this.props;

    const Btn = buttons[type].withComponent(this.componentType());
    const newProps = { ...Button, ...this.props };

    return <Btn {...newProps} />;
  }
}

// TODO: May be able to remove withTrackingPropsProvider by default.
export default withTrackingPropsProvider(withTheme(Button), { id: 'children' });
